import '../StrongRegistrationModal.css';
import { CheckIcon } from '../../Icons';
import { useLanguage } from '../../../locale/useLanguage';
import { ReactComponent as RegistrationImage } from '../../../assets/images/registration-modal.svg';
import { Button } from '../../Button/Button';
import { Routes } from '../../../routes/types';
import { useHistory } from 'react-router-dom';
import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
} from 'react';
import { Modal, ModalRef } from '../../Modal/Modal';
import { Config } from '../../../helpers/config';

const SignInUpModal: React.ForwardRefExoticComponent<
  React.RefAttributes<ModalRef>
> = forwardRef((_, forwardedRef) => {
  const [t] = useLanguage();
  const history = useHistory();
  const modalRef = useRef<ModalRef>(null);

  useImperativeHandle(forwardedRef, () => ({
    openModal: modalRef.current!.openModal,
    closeModal: modalRef.current!.closeModal,
  }));

  const goToSignIn = useCallback(() => {
    history.push(Routes.SignIn);
  }, [history]);

  const goToSignUp = useCallback(() => {
    history.push(Routes.SignUp);
  }, [history]);

  return (
    <Modal ref={modalRef}>
      <div className="modal-title">{t('registrationModal.title')}</div>
      <div className="modal-subtitle">{t('registrationModal.subTitle')}</div>
      <div className="registrationModal--image-container">
        <RegistrationImage className="registrationModal--image" />
      </div>
      <div className="modal-content-title">
        {t('registrationModal.contentTitle')}
      </div>
      <div className="registrationModal--container">
        <div className="registrationModal--check1">
          <CheckIcon color={Config.primaryBlue} />
        </div>
        <div className="registrationModal--text1">
          {t('registrationModal.firstBenefit')}
        </div>

        <div className="registrationModal--check2">
          <CheckIcon color={Config.primaryBlue} />
        </div>
        <div className="registrationModal--text2">
          {t('registrationModal.secondBenefit')}
        </div>
        <div className="registrationModal--check3">
          <CheckIcon color={Config.primaryBlue} />
        </div>
        <div className="registrationModal--text3">
          {t('registrationModal.thirdBenefit')}
        </div>

        <div className="registrationModal--check4">
          <CheckIcon color={Config.primaryBlue} />
        </div>
        <div className="registrationModal--text4">
          {t('registrationModal.fourthBenefit')}
        </div>
      </div>
      <div className="modal-button-container">
        <Button
          onClick={goToSignUp}
          label={t('requestSignUpModal.signUp')}
          isPrimary
        />
        <div className="change-address-confirm-modal--exit-button">
          <Button onClick={goToSignIn} label={t('requestSignUpModal.signIn')} />
        </div>
      </div>
    </Modal>
  );
});

export default SignInUpModal;
